import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	vesselsList: [],
	masterData: [],
};

export const myFleetSlice = createSlice({
	name: "myFleet",
	initialState,
	reducers: {
		saveVesselsList: (state, actions) => {
			state.vesselsList = actions.payload.vesselsList;
		},
		editVessel: (state, actions) => {
			
		},
		setMasterData: (state, actions) => {
			state.masterData = actions.payload.masterData;
		},

		deleteVessel: (state, actions) => {
			// Assuming your records have unique IDs, filter out the deleted record
			return state.filter((record) => record.id !== actions.payload);
		},
		saveConsumerRegistryPayload: (state, actions) => {
			state.consumerRegistryPayload =
				actions.payload.consumerRegistryPayload;
		},
		saveFuelRegistryPayload: (state, actions) => {
			state.fuelRegistryPayload = actions.payload.fuelRegistryPayload;
		},
	},
});

export const myFleetActions = myFleetSlice.actions;
export default myFleetSlice.reducer;
